export default __webpack_public_path__ + "static/linkedin-476d5ac5c82fd705d44b475f63235eb4.png";